import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { useState, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';
import NvTooltipBody from './NvTooltipBody/NvTooltipBody.esm.js';

var NvTooltip = React__default.forwardRef(function (_a, ref) {
    var _b = _a.position, position = _b === void 0 ? 'top' : _b, _c = _a.trigger, trigger = _c === void 0 ? 'hover' : _c, _d = _a.hasChildrenWrapper, hasChildrenWrapper = _d === void 0 ? true : _d, children = _a.children, onVisibilityChange = _a.onVisibilityChange, destroyTooltipOnHide = _a.destroyTooltipOnHide, tooltipClassName = _a.tooltipClassName, id = _a.id, wrapperClassName = _a.wrapperClassName, getTooltipContainer = _a.getTooltipContainer, props = __rest(_a, ["position", "trigger", "hasChildrenWrapper", "children", "onVisibilityChange", "destroyTooltipOnHide", "tooltipClassName", "id", "wrapperClassName", "getTooltipContainer"]);
    var _e = __read(useState(false), 2), isVisible = _e[0], setIsVisible = _e[1];
    var timeHoverTooltip = React__default.useRef(null);
    var calculateHoverTime = function (visible) {
        if (visible)
            timeHoverTooltip.current = new Date();
        if (!visible && timeHoverTooltip.current) {
            var seconds = (new Date().getTime() - timeHoverTooltip.current.getTime()) / 1000;
            timeHoverTooltip.current = null;
            return seconds;
        }
        return null;
    };
    var handleVisibilityTooltip = useCallback(function (visible) {
        setIsVisible(visible);
        var duration = calculateHoverTime(visible);
        if (onVisibilityChange)
            onVisibilityChange({ duration: duration, visible: visible });
    }, [onVisibilityChange]);
    /**
     * Exposes a method to control visibility from parent via refs
     * @see https://reactjs.org/docs/hooks-reference.html#useimperativehandle
     * @see https://ilxanlar.medium.com/useimperativehandle-by-examples-85b753a39c41
     *
     * When NvTooltip is tied to a ref, the parent component may call ref.current.setIsVisible()
     * to control tooltip visibility programmatically
     */
    useImperativeHandle(ref, function () { return ({
        setIsVisible: function (isVisible) {
            handleVisibilityTooltip(isVisible);
        },
    }); });
    if (!props.title && !props.text && !props.overlayContent) {
        return children;
    }
    return (React__default.createElement(Tooltip, { align: {
            overflow: {
                adjustX: true,
                adjustY: true,
                shiftX: true,
                shiftY: true,
            },
        }, destroyTooltipOnHide: destroyTooltipOnHide, getTooltipContainer: getTooltipContainer, id: id, onVisibleChange: handleVisibilityTooltip, overlay: React__default.createElement(NvTooltipBody, __assign({}, props, { closeTooltip: function () { return handleVisibilityTooltip(false); } })), overlayClassName: tooltipClassName, placement: position, trigger: trigger, visible: isVisible }, hasChildrenWrapper ? (React__default.createElement("div", { className: classNames(wrapperClassName, 'wrapperChildren'), "data-testid": "tooltip-wrapper" }, children)) : (children)));
});
NvTooltip.displayName = 'NvTooltip';

export { NvTooltip as default };
//# sourceMappingURL=NvTooltip.esm.js.map
